import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { check } from './../helpers/browser';

const styles = theme => ({
    textStatic: {
        margin: "20px 0",
        maxWidth: "65%",
        color: "#5b5b5b"
    }
});

export class OldBrowserMessage extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {classes} = this.props;
        let bData = check();
        if (bData.browserName =='Microsoft Internet Explorer' && (bData.majorVersion < 11)) {
            return  (<Typography className={classes.textStatic}>Версия вашего браузера устарела. Обновите браузер до актуальной версии.</Typography>);
        }
        else {
         return (null);
        }
    }
}

export default withStyles(styles)(OldBrowserMessage);



// WEBPACK FOOTER //
// ./assets/src/js/components/OldBrowserMessage.jsx